import React from 'react';
import { useTranslation } from "react-i18next";
import { db } from "../controllers/DB";
import { generateID } from "../controllers/misc";
import Api from "../api/api-wizard";
import Moment from 'react-moment';
import 'moment/locale/es';

function Contact() {

  const saveAccount = (steps) => {

    if (typeof (steps.id) != "undefined")
      Api.put({ url: '/account/add', params: steps })
        .then(data => {
          console.log(data);
        })
        .catch(err => {
          console.log(err);
        });
  }

  const params = new URLSearchParams(window.location.search);


  const confirmContact = (ev = false, next = false) => {
    if (ev)
      ev.preventDefault();

    const urlParams = window.location.href.split("?");
    steps.record = record;
    steps.channel = channelID;
    steps.date_start = steps.date_start;
    steps.field = "88";

    Api.post({ url: '/account/funnel/contact', params: steps })
      .then(data => {

        if (next)
          return next();

        if (urlParams.length > 1) {
          window.location.href = `/scheduled?${urlParams[1]}`;
        } else {
          window.location.href = '/scheduled';
        }
      })
      .catch(err => {
        console.log(err);
      });
  }


  const { t } = useTranslation(),
    [isLoaded, set_isLoaded] = React.useState(false),
    [channelID, set_channelID] = React.useState(params.get('channel')),
    [channel, set_channel] = React.useState(params.get('channel')),
    [record, set_record] = React.useState(params.get('id')),
    [steps, setData] = React.useState(async () => {
      db.steps.get(localStorage.getItem("wizardID")).then(dat => {
        setData(dat);
        set_isLoaded(true);
      });
    });

  const datesRange = [];

  for (let i = 0; i < 10; i++) {
    datesRange.push({
      name: <Moment locale="gt" format='dddd DD [de] MMM' add={{ days: i }}></Moment>,
      value: new Date(Date.now() + (3600 * 1000 * (24 * i))).toLocaleDateString("es-US"),
    });
  }

  const hours = ['09:00', '10:00', '11:00', '12:00', '14:00', '15:00', '16:00', '17:00'];

  React.useEffect(() => {

    db.steps.get(localStorage.getItem("wizardID")).then(dat => {

      if (typeof (dat) == "undefined") {
        db.steps.add(steps);
      } else {
        db.steps.update(localStorage.getItem("wizardID"), steps);
      }
    });
  });

  switch (channel) {
    case 'whatsapp':

      set_channel('Whatsapp');
      confirmContact(false, () => {
        window.location.href = "whatsapp://send?phone=50224444722";
      });

      break;
    case 'call':
      set_channel('Llamada telefónica');
      break;
    case 'videocall':
      set_channel('Videoconferencia');
      break;
    case 'mail':
      set_channel('Correo electrónico');
      confirmContact(false, () => {

        const urlParams = window.location.href.split("?");

        if (urlParams.length > 1) {
          window.location.href = `/scheduled?${urlParams[1]}`;
        } else {
          window.location.href = '/scheduled';
        }
      });
      break;
  }

  return (
    <div>
      <div style={{ Index: "-1", height: window.innerHeight, backgroundImage: "url('https://files.signuscorp.com/?business=1&file=MTYzMTdlMWZjYmI5ODc=')", backgroundSize: 'cover', "-webkit-filter": 'blur(2px)' }}>
        <div style={{ background: "#000", opacity: "0.7", height: window.innerHeight }}></div>
      </div>

      <div class="row content-register" style={{ borderRadius: "20px", left: "15%", marginTop: "7.5%", height: "70%", width: "70%", background: "white", top: "0px", zIndex: "2", position: "absolute", "-webkit-filter": 'blur(0px) !important' }}>
        <div class="col-lg-4" style={{ borderRadius: "20px 0px 0px 20px", backgroundImage: "url('https://files.signuscorp.com/?business=1&file=MTYzMTc4OWI4MWUxNDg=')", backgroundSize: 'cover' }}>
        </div>
        <div class="col-lg-8" style={{ height: "100%", overflow: "auto" }}>
          <form class="row" onSubmit={confirmContact} style={{ marginTop: "30px", marginLeft: "5%", width: "90%" }}>
            <div class="col-md-12">
              <h2 class="mb-0">Nos ajustamos a tu horario.</h2>
              <p class="lead mb-0">Por favor elige el horario que consideres más conveniente para ponernos en contacto.</p><br />
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label>Elija la fecha</label>
                <select class="form-control" data-error="Valor requerido."
                  onChange={e => setData((prevState) => ({ ...prevState, date_start: e.target.value }))} required>
                  {isLoaded && datesRange.map((dat) => {
                    return <option value={dat.value}>{dat.name}</option>
                  })}
                </select>
                <div class="help-block with-errors"></div>
              </div>
              {hours.map((ho) => {
                return <div class="col-3" style={{ marginBottom: "10px" }}>
                  <input type="radio" class="btn-check" defaultValue={ho} name="options" id={ho} autocomplete="off"
                    onChange={e => setData((prevState) => ({ ...prevState, hour: e.target.value }))} />
                  <label class="btn btn-sm btn-secondary" for={ho}>{ho}</label>
                </div>
              })}
            </div>
            <div class="col-12">
              <button class="btn btn-primary btn-block"><span>Confirmar cita a las <b>{steps.hour}</b> horas por <b>{channel}</b></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div >
  );
}

export default Contact;
